import {api} from '../../system/api';

export default {
    fetchProperty: (params) => api.get('properties', {params}),
    fetchDetailProperty: (propertyId) => api.get('properties/' + propertyId),
    fetchPropertySuggest: () => api.get('properties/suggest'),
    createProperty: (params) => api.post('properties', {...params}),
    updateProperty: (params) => api.put('properties/' + params.id_property, {...params}),
};
